import { TabPane } from 'reactstrap'
import AccountMoveItemsTable from '../AccountMoveItemsTable';

const LineaTab = (props) => {

    const { form, disabled, setFormState } = props;

    return(
        <TabPane tabId="1" className="pt-3">
          <AccountMoveItemsTable
            disabled={disabled}
            form={form}
            setFormState={setFormState}
            // addItem={addItem}
          />
        </TabPane>
    )
}

export default LineaTab